import React from 'react';
import './startup.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { motion } from 'framer-motion';

// Placeholder data for blogs. Update these objects with real LinkedIn URLs and text later!
const blogData = [
  {
    id: 1,
    title: "The Future of AI Without Billions of Training Data💫",
    excerpt: "The AI industry is at a crossroads. With compute costs soaring and data quality diminishing, the era of massive, billion-parameter models trained on infinite data may be ending. But what if there’s another way?",
    date: "January 2026",
    link: "https://www.linkedin.com/posts/sharad-naik-b3238b239_the-future-of-ai-without-billions-of-training-activity-7400892324416872448-MQuz?utm_source=share&utm_medium=member_desktop&rcm=ACoAADtSjJYBwQ6v8rF-tXMWPCusmnFTCbk9BQA"
  },
  {
    id: 2,
    title: "Advanced RAG Retrieval: The Ultimate Cheat Sheet",
    excerpt: "A comprehensive guide to advanced RAG retrieval techniques, covering everything from basic concepts to the latest innovations.",
    date: "March 2026",
    link: "https://www.linkedin.com/pulse/advanced-rag-retrieval-ultimate-cheat-sheet-sharad-naik-it9yc"
  },
  // {
  //   id: 3,
  //   title: "IoT For Everyone: Automating My Room",
  //   excerpt: "Taking a weekend to hook up an ESP-32 local server to completely automate my environment based on thermal sensors...",
  //   date: "January 28, 2026",
  //   link: "https://www.linkedin.com/in/sharad-naik-b3238b239/"
  // }
];

const Startup = () => {
  return (
    <div className='blog-section' id="startup">
      <div className="blog-header">
        <span className='stroke-text'>Latest</span>
        <span> Insights & Blogs</span>
        <p className="blog-subtitle">Thoughts on technology, AI, and software engineering published on LinkedIn.</p>
      </div>

      <div className="blog-grid">
        {blogData.map((blog, index) => (
          <motion.div 
            key={blog.id} 
            className="blog-card"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
            viewport={{ once: true }}
          >
            <div className="blog-card-header">
              <FontAwesomeIcon icon={faLinkedin} className="blog-li-icon" />
              <span className="blog-date">{blog.date}</span>
            </div>
            
            <h3 className="blog-title">{blog.title}</h3>
            <p className="blog-excerpt">{blog.excerpt}</p>
            
            <button 
              className="blog-read-btn" 
              onClick={() => window.open(blog.link, '_blank')}
            >
              Read Article <FontAwesomeIcon icon={faArrowRight} style={{ marginLeft: '8px' }} />
            </button>
          </motion.div>
        ))}
      </div>
    </div>
  );
}

export default Startup;